module.exports = __webpack_public_path__ + "static/img/partIcon04.f2c12cfb.png";